import { render, staticRenderFns } from "./mm_brochures.vue?vue&type=template&id=18b19a8c&"
import script from "./mm_brochures.vue?vue&type=script&lang=js&"
export * from "./mm_brochures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports